import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ScrollListService { 
    activeIndexItem$ = new Subject<number>();

    setActiveIndex(index: number) {
        this.activeIndexItem$.next(index);
    }
}